import { ORDER_STATUSES } from '@witmetrics/utils/constants';
import { buildStatusOption } from '@witmetrics/unison-core';

export const STATUS_OPTIONS =
  Object.values(ORDER_STATUSES).map(buildStatusOption);
